
import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators,FormsModule } from '@angular/forms';
import * as moments from 'moment';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { UsersettingService } from 'src/app/services/usersetting.service';
import { ValidationService } from 'src/app/services/validation.service';
import { CommonService } from '../../services/common.service';
import * as moment from 'moment-timezone';
import { ExternalLibraryService } from 'src/app/services/payment.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';
declare var $: any;
declare let Razorpay: any;
import * as FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';
import jsPDF from 'jspdf';
import htmlToPdfmake from 'html-to-pdfmake';
import pdfMake from 'pdfmake/build/pdfmake';
@Component({
  selector: 'app-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.css']
})
export class TaskListComponent implements OnInit {
  @ViewChild('pdfTable') pdfTable: ElementRef;
  form:FormGroup;
  modelForm:FormGroup;
  dealerList =[];
  pageOption = 10;
  pageOptionModal = 10;
  page: number = 1;
  submitted = false;
  myDealerControl:FormControl;
  userId = localStorage.getItem('userId');
  userData = {};
  userdata:any;
  filteredOptions: Observable<any[]>;
  licensesList = [];
  addLicensesForm: any;
  editCustomerForm: FormGroup;
  timezoneArray = [];
  showModal = false;
  deviceList: any = [];
  errors: any = {};
  response;
  superAdmin:boolean = false;
  razorpayResponse;
  modalRef?: BsModalRef;
  selectedClientId='';
  selectedDriverId='';
  selectedSupervisorId='';
  inputFromDate: any = '';
  inputToDate: any= '';
  tableForPdfColumns:any[] = [];
  tableForPdfContent: any[][] = [];
  RAZORPAY_OPTIONS = {
    "key": "rzp_test_BClgEY2hkt8ayQ",
    "amount": "100",
    "name": "",
    "currency":'INR',
    "order_id": "",
    "description": "purchase license",
    "image": `https://${environment.baseUrl}/assets/images/main-logo.png`,
    "prefill": {
      "name": "",
      "email": "test@test.com",
      "contact": "",
      "method": ""
    },
    "modal": {},
    "theme": {
      "color": "#0096C5"
    }
  };
  fileType =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
fileExtension = '.xlsx';
  @Input()
  addMode = false;
  @Input()
  gridMode = false;
  taskListData: any[] = [];
  reportsName= 'Trips';
  clientName:string ='';
  driverName:string ='';
  supervisorName:string='';
  xlsxFileData: any[];
  orgId: any;
  customerList: any;
  clientList: any;
  driverList: any;
  empList:any;
  managerList:any;
  tmanagerList:any;
  supervisorList: any;
  fromdateP='';
  todateP='';
  formattedFromDate:any ;
  formattedToDate:any
   dayType = 'Today';
   status:string='';
  isClient: boolean = false;
  clientName1: any='';
  htmlString: string='';
  constructor(
    private modalService: BsModalService,
    private user: UsersettingService,
    private fb: FormBuilder,
    private customValidator: ValidationService,
    private commonService: CommonService,
    private razorpayService: ExternalLibraryService, private cd:  ChangeDetectorRef,
    private datePipe: DatePipe,
  ) {
    this.commonService.pageLoadInModal.subscribe((result: string) => { 
      if (result == "tasklist") {
        this.gridMode = true;
        this.addMode = false;
      }
    });
    this.myDealerControl = new FormControl();
    let userData = localStorage.getItem('userData');
   this.userData = userData ? JSON.parse(userData) : {};
   
   this.initPaymentForm();
  }
  
  ngOnInit(): void {
    let today = moment();
    this.fromdateP = today.format("DD/MM/YYYY");
    this.todateP = today.format("DD/MM/YYYY");
    let userDataObj = localStorage.getItem('userData');
    if (userDataObj) {
      try {
        this.userdata = JSON.parse(userDataObj);
       
        console.log('USer data =>',this.userdata)
        if(this.userdata.attributes.role === 'admin'){
       this.orgId=this.userdata.id;
       
      }
      else if(this.userdata.attributes.role === 'clients'){
        this.orgId=this.userdata.orgId;
        this.isClient = true;
        this.clientName1=this.userdata.email;
      }
      else{
        this.orgId = this.userdata.orgId;
      }

      // if(this.userdata.attributes.role == "clients"){
         
      // }
      } catch (error) {}
    }


  
   
    this.filteredOptions = this.myDealerControl.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filter(name as string) : this.dealerList.slice();
      }),
    );
    this.superAdmin = this.userData && this.userData['administrator'];
    //if(this.superAdmin){
      this.getAllCustomers();
    //}
    this.form = new FormGroup({
      searchValue: new FormControl(''),
    });
    
    this.modelForm = new FormGroup({
      searchValue: new FormControl(''),
    });
    this.getAllLicenses();
    this.initPaymentFlow();
    // this.getAllTaskData();

    this.fetchTasks();
  }
  getAllCustomers() {
    // this.user.getCustomers().subscribe(resp => {
    //   this.customerList = resp;
    // })
    //console.log("Customer api called");
    this.commonService.getRequest(`users?orgId=${this.orgId}`, []).then((resp: any) => {
      if (resp?.status) {
        this.customerList = resp.data;
        //this.usersList = this.customerList.filter(customer=>!customer.administrator && customer.userLimit === 0); 
        //if(this.currentUrl.isDealer) {
          this.clientList = this.customerList.filter(customer=> customer.attributes?.role == 'clients');
          this.supervisorList = this.customerList.filter(customer=> customer.attributes?.role == 'sv');
          this.driverList = this.customerList.filter(customer=> customer.attributes?.role == 'driver');
          // this.empList = this.customerList.filter(customer=> customer.attributes?.role == 'emp');       

    //  console.log('cleint list',this.clientList)
    //  console.log('supervisor list',this.supervisorList)
    //  console.log("driver list",this.driverList);
    //  console.log("emp list",this.empList);
        // }else {
        //   this.customerList = this.customerList.filter(customer=> customer.attributes?.role == 'driver');
        // }
      }
    });
  }

  onClientSelect() {
  
    // Find the selected client from clientList and extract the ID
    if(this.clientName !== "0"){
      const selectedClient = this.clientList.find(client => client.name === this.clientName);
      this.selectedClientId = selectedClient ? selectedClient.email : '';
       console.log('Client id',this.selectedClientId);
    }
    else{
      this.selectedClientId= '';
    }
    // You can do additional logic here based on the selected client if needed
  }
  onDriverSelect() {
  if(this.driverName !== "0"){
    // Find the selected client from clientList and extract the ID
    const selecteddriver = this.driverList.find(driver => driver.name === this.driverName);
    this.selectedDriverId = selecteddriver ? selecteddriver.id : 0;
     console.log('driverid',this.selectedDriverId);
    // You can do additional logic here based on the selected client if needed

  }
  else{
    this.selectedDriverId ="";
  }

  }
  onSupervisorSelect() {
  
    // Find the selected client from clientList and extract the ID
    const selectedSupervisor = this.supervisorList.find(client => client.name === this.supervisorName);
    this.selectedSupervisorId = selectedSupervisor ? selectedSupervisor.id : 0;
     console.log('Client id',this.selectedSupervisorId);
    // You can do additional logic here based on the selected client if needed
  }

  filteredData(){
debugger
    this.formattedFromDate = this.fromdateP ? `${this.fromdateP}T00:00:00Z`: '';
    this.formattedToDate = this.todateP ? `${this.todateP}T23:59:59Z` : '';
    const assignedTo:any = this.selectedDriverId ?? '';
    const supervisorId:any = '';

    this.inputFromDate=  moment(this.fromdateP, 'DD/MM/YYYY').toDate();
    this.inputToDate = moment(this.todateP, 'DD/MM/YYYY').toDate();
   console.log(this.inputFromDate)
      // this.inputFromDate = new Date(this.fromdateP);
      // this.inputToDate = new Date(this.todateP);
    this.formattedFromDate = this.inputFromDate.toISOString().slice(0, 10) + 'T00:00:00Z';
    this.formattedToDate = this.inputToDate.toISOString().slice(0, 10) + 'T23:59:59Z';
    
    // const fromDate = this.formattedFromDate ?? '';
    // const toDate = this.formattedFromDate ?? '';
    const clientId:any = this.selectedClientId ?? '';

    if(this.isClient){
      this.commonService.getTasks(`traccartasks/orgId/${this.orgId}`,assignedTo, supervisorId, this.formattedFromDate, this.formattedToDate, this.clientName1,this.status)
      .subscribe((response) => {
        this.taskListData = response
        console.log(response);
      }, (error) => {
        // Handle errors here
        console.error(error);
      });
    }
    else{
      this.commonService.getTasks(`traccartasks/orgId/${this.orgId}`,assignedTo, supervisorId, this.formattedFromDate, this.formattedToDate, clientId,this.status)
      .subscribe((response) => {
        this.taskListData = response
      
      }, (error) => {
        // Handle errors here
        console.error(error);
      });
    }
   

 
  }

  fetchTasks() {

    const today = new Date();
    const formattedToday = today.toISOString().slice(0, 10) + 'T00:00:00Z';
    const formattedToday1 = today.toISOString().slice(0, 10) + 'T23:59:59Z';

      this.commonService.getClientTasks(`traccartasks/clientId/${this.clientName1}`)
      .subscribe((response) => {
        this.taskListData = response;
        console.log(response);
      }, (error) => {
      
        console.error(error);
      });
    // if(this.isClient){
    //   this.commonService.getTasks(`traccartasks/orgId/${this.orgId}`,'', '', formattedToday, formattedToday1, this.clientName1,'')
    //   .subscribe((response) => {
    //     this.taskListData = response;
    //     console.log(response);
    //   }, (error) => {
      
    //     console.error(error);
    //   });
    // }
    // else{
    //   this.commonService.getTasks(`traccartasks/orgId/${this.orgId}`,'', '', formattedToday, formattedToday1, '','')
    //   .subscribe((response) => {
    //     this.taskListData = response;
    //     console.log(response);
    //   }, (error) => {
      
    //     console.error(error);
    //   });
    // }
 
  }    
  dealerChange() {
    console.log(this.addLicensesForm.userId);
  }
  initPaymentForm(){   
  let userDataAttr = this.userData['attributes'] && this.userData['attributes'].unitrate ? this.userData['attributes'] :{
    "unitrate": "100",
    "currency": "INR"
  }
   this.addLicensesForm = {
    amount: parseInt(userDataAttr.unitrate),
    currency: userDataAttr.currency,
    devicecount: 0,
    total:0,
    tax:18,
    userId:0,
    status:'Completed',
  };
}

getAllTaskData() {
 

  this.commonService.getRequest(`traccartasks/orgId/${this.orgId}`, []).then((resp: any) => {
    // console.log("tasks data");
    // console.log(resp);
    if (resp?.status) {
        this.taskListData = resp.data;
    }
  });
  // this.commonService.getRequest('traccartasks/createdTaks', []).then((resp: any) => {
  //   // console.log("tasks data");
  //   // console.log(resp);
  //   if (resp?.status) {
  //       this.taskListData = resp.data;
  //   }
  // });
}
  searchData() {
    
  }
    getAllLicenses() {
    
    this.commonService.getRequest( this.superAdmin ? 'razorpay/listAllLicenses' : 'razorpay', [],false,false).then((resp: any) => {
      if (resp?.status) {
        this.licensesList = resp.data;
       
      }
    });
  }

  onOrderPlace() {
    this.errors = {};
    let error = false;
    if(!this.addLicensesForm.total) {
      this.errors.total = 'Amount is required field';
      error = true;
    } 
    if(!this.addLicensesForm.devicecount) {
      this.errors.devicecount = 'Count is required field';
      error = true;
    } 
    if(!this.addLicensesForm.currency) {
      this.errors.currency = 'Currency is required field';
      error = true;
    } 
    if( !this.addLicensesForm.status && this.superAdmin) {
      this.errors.status = 'Status is required field';
      error = true;
    } 
    if(!(this.addLicensesForm.userId  && this.myDealerControl.value) && this.superAdmin) {
      this.errors.userId = 'Dealer is required field';
      error = true;
    } 
    if(!error) {
      if(this.superAdmin) {
        this.manualLicence();
      } else {
        this.addLicense();
      }
    }
    
  }
  addLicense(){
    const body = new HttpParams()
    .set('amount', this.addLicensesForm.total)
    .set('currency', this.addLicensesForm.currency)
    .set('devicecount', this.addLicensesForm.devicecount);
   // $('#staticBackdrop').modal('show');
    this.commonService
    .postFormRequest('razorpay/order', body,true)
    .then((resp: any) => {
      console.log(resp);
      if (resp?.status && resp?.data?.orderId) {
        //$('#staticBackdrop').modal('hide');
        this.gridMode = true;
        this.addMode = false;
        this.addLicensesForm.orderId = resp.data.orderId;
        this.proceed(resp.data.orderId)
      }
    });
  }
  manualLicence() {
    // const body = new HttpParams()
    // .set('amount', this.addLicensesForm.total)
    // .set('currency', this.addLicensesForm.currency)
    // .set('devicecount', this.addLicensesForm.devicecount);
    let bodyObj = {
      "userId": this.addLicensesForm.userId,
      "units": this.addLicensesForm.devicecount,
      "amount": this.addLicensesForm.total,
      "currency": this.addLicensesForm.currency,
      "status": this.addLicensesForm.status,
      "recepitNo": "",
      "orderId": "",
      
      "transactiondate": (new Date()).toISOString()
  }
    //$('#staticBackdrop').modal('show');
    this.commonService
    .postRequest('razorpay/manualAddLicense', bodyObj)
    .then((resp: any) => {
        //$('#staticBackdrop').modal('hide');
        this.gridMode = true;
        this.addMode = false;
        this.getAllLicenses();
    });
  }
  
  dealerSelected(dealer) {
    this.addLicensesForm.userId = dealer && dealer.id? dealer.id : '';  
  }
  displayFn(dealer: any): string {
    return dealer && dealer.name ? dealer.name : '';
  }
  private _filter(name: string): any[] {
    const filterValue = name.toLowerCase();

    return this.dealerList.filter(option => option.name.toLowerCase().includes(filterValue));
  }
  onChangeCount() {
    let totalPrice  = this.addLicensesForm.amount * this.addLicensesForm.devicecount;
    this.addLicensesForm.total =totalPrice + totalPrice*this.addLicensesForm.tax/100;
  }

  purchaseLicense() {
    this.gridMode = false;
    this.addMode = true;
  }
  initPaymentFlow() {
    this.razorpayService
    .lazyLoadLibrary('https://checkout.razorpay.com/v1/checkout.js')
    .subscribe();
  }
  public proceed(orderId) {
    this.RAZORPAY_OPTIONS.amount = (this.addLicensesForm.total).toString();
    this.RAZORPAY_OPTIONS.order_id = orderId
    //this.RAZORPAY_OPTIONS.currency = this.addLicensesForm.currency;

    // binding this object to both success and dismiss handler
    this.RAZORPAY_OPTIONS['handler'] = this.razorPaySuccessHandler.bind(this);

    // this.showPopup();

   let razorpay = new Razorpay(this.RAZORPAY_OPTIONS)
    razorpay.open();
  }

  public razorPaySuccessHandler(response) {
    console.log(response);
   
    this.cd.detectChanges()
   this.verifyOrder(response.razorpay_payment_id);
  }
  verifyOrder(paymentId,orderStatus="success",details='') {
    let postData = {
      "orderId":this.addLicensesForm.orderId,
      "paymentId":paymentId,
      "failureDetails":details,
      "razorPayPaymentStatus":orderStatus,
    }
    
    this.commonService
      .postRequest('razorpay/verifyPayment', postData)
      .then((resp: any) => {
        console.log(resp);
        this.gridMode = true;
        this.addMode = false;
        this.getAllLicenses();
      });
  }
  addLicenseButton() {
    this.gridMode = false;
    this.addMode = true;
  }
  onCancelClick() {
    this.gridMode = true;
    this.addMode = false;
  }
  exporttoExcel() {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.taskListData);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, 'task_data.xlsx');
  }

  download(){
    
    let tableList = [];
    tableList = [
      {
        titleName: 'Task ID',
        type: '',
        filter: '',
        hirarchy: [],
        isHirarchy: false,
        colName: 'id',
      },
      {
        titleName: 'Type',
        type: '',
        filter: '',
        hirarchy: [],
        isHirarchy: false,
        colName: 'type',
      },
      {
        titleName: 'Description',
        type: '',
        filter: '',
        hirarchy: [],
        isHirarchy: false,
        colName: 'name',
      },
      {
        titleName: 'Address',
        type: '',
        filter: '',
        hirarchy: [],
        isHirarchy: false,
        colName: 'pickuplocation',
      },
      {
        titleName: 'Created by',
        type: '',
        filter: '',
        hirarchy: [],
        isHirarchy: false,
        colName: 'createdBy',
      },
      {
        titleName: 'Start before',
        type: 'date',
        filter: '',
        format: 'dd/MM/yyyy hh:mm a',
        hirarchy: [],
        isHirarchy: false,
        colName: 'expectedstarttime',
      },
      {
        titleName: 'Status',
        type: '',
        filter: '',
        hirarchy: [],
        isHirarchy: false,
        colName: 'status',
      },
      {
        titleName: 'Pickup/Delivery',
        type: '',
        filter: '',
        hirarchy: [],
        isHirarchy: false,
        colName: 'type',
      }
    ]
    this.xlsxFileData = [];
        this.exportexcel();
    }
    downloadData(type) {
debugger
      let tableList = [];
      switch (this.reportsName) {
        case 'Route':
          tableList = [
            {
              titleName: 'Device Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'device_Name',
            },
            {
              titleName: 'Latitude',
              type: 'number',
              filter: '',
              format: '1.0-6',
              hirarchy: [],
              isHirarchy: false,
              colName: 'latitude',
            },
            {
              titleName: 'Longitude',
              type: 'number',
              filter: '',
              format: '1.0-6',
              hirarchy: [],
              isHirarchy: false,
              colName: 'longitude',
            },
            {
              titleName: 'Speed',
              type: 'number',
              filter: 'userbased',
              format: '1.0-2',
              hirarchy: [],
              isHirarchy: false,
              colName: 'speed',
            },
            {
              titleName: 'Odometer',
              type: '',
              filter: 'meterTokm',
              format: '',
              isHirarchy: true,
              hirarchy: ['attributes', 'odometer'],
              colName: 'odometer',
            },
            // {
            //   titleName: 'Fix Time',
            //   type: 'date',
            //   filter: '',
            //   format: 'dd/MM/yyyy hh:mm a',
            //   hirarchy: [],
            //   isHirarchy: false,
            //   colName: 'fixTime',
            // },
            // {
            //   titleName: 'Device Time',
            //   type: 'date',
            //   filter: '',
            //   format: 'dd/MM/yyyy hh:mm a',
            //   hirarchy: [],
            //   isHirarchy: false,
            //   colName: 'deviceTime',
            // },
            {
              titleName: 'Address',
              type: 'address',
              filter: '',
              format: '',
              isHirarchy: false,
              hirarchy: [],
              colName: 'address'
            },
            {
              titleName: 'Server Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'serverTime',
            }
          ];
          break;
        case 'Events':
          tableList = [
            {
              titleName: 'Device Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'deviceName',
            },
            {
              titleName: 'Fixt Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'eventTime',
            },
            {
              titleName: 'Address',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['latLng', 'address'],
              isHirarchy: true,
              colName: 'latLng',
            },
            {
              titleName: 'Type',
              type: '',
              filter: '',
              format: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'type',
            },
            {
              titleName: 'Alarm',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['attributes', 'alarm'],
              isHirarchy: true,
              colName: 'alarm',
            },
            {
              titleName: 'Remarks',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['attributes', 'remarks'],
              isHirarchy: true,
              colName: 'remarks',
            },
          ];
          break;
        case 'AC Report':
          tableList = [
            {
              titleName: 'Device Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'deviceName',
            },
            {
              titleName: 'Address',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['latLng', 'address'],
              isHirarchy: true,
              colName: 'latLng',
            },
            {
              titleName: 'Fixt Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'eventTime',
            },
            {
              titleName: 'Type',
              type: '',
              filter: '',
              format: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'type',
            }
          ];
          break;
        case 'Ignition Report':
          tableList = [
            {
              titleName: 'Device Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'deviceName',
            },
            {
              titleName: 'Address',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['latLng', 'address'],
              isHirarchy: true,
              colName: 'latLng',
            },
            {
              titleName: 'Fixt Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'eventTime',
            },
            {
              titleName: 'Type',
              type: '',
              filter: '',
              format: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'type',
            }
          ];
          break;
        case 'Geofence':
            tableList = [
              {
                titleName: 'Device Name',
                type: '',
                filter: '',
                hirarchy: [],
                isHirarchy: false,
                colName: 'deviceName',
              },
              {
                titleName: 'Geofence',
                type: '',
                filter: '',
                hirarchy: [],
                isHirarchy: false,
                colName: 'geoName',
              },
              {
                titleName: 'Fixt Time',
                type: 'date',
                filter: '',
                format: 'dd/MM/yyyy hh:mm a',
                hirarchy: [],
                isHirarchy: false,
                colName: 'eventTime',
              },
              {
                titleName: 'Address',
                type: '',
                filter: '',
                format: '',
                hirarchy: ['latLng', 'address'],
                isHirarchy: true,
                colName: 'latLng',
              },
              {
                titleName: 'Type',
                type: '',
                filter: '',
                format: '',
                hirarchy: [],
                isHirarchy: false,
                colName: 'type',
              },
              {
                titleName: 'Alarm',
                type: '',
                filter: '',
                format: '',
                hirarchy: ['attributes', 'alarm'],
                isHirarchy: true,
                colName: 'alarm',
              },
            ];
            break;
        case 'Trips':
          tableList = [
            {
              titleName: 'Task ID',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'id',
            },
            {
              titleName: 'Client Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'clientid',
            },
            {
              titleName: 'Task Type',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'type',
            },
            {
              titleName: 'Address',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'pickuplocation',
            },
            {
              titleName: 'Status',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'status',
            },
            {
              titleName: 'Driver Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'name',
            },
           
          
            {
              titleName: 'Created Date',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'date',
            },
            {
              titleName: 'Start Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'actualstarttime',
            },
            {
              titleName: 'End Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'actualendtime',
            },
        
            {
              titleName: 'Distance',
              type: '',
              filter: '',
              format: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'distanceInKm',
            },
            {
              titleName: 'Duration',
              type: '',
              filter: '',
              format: 'hh:mm',
              isHirarchy: false,
              colName: 'duration',
            },
            {
              titleName: 'Remarks',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'remarks',
            },
            // {
            //   titleName: 'Odometer Start',
            //   type: '',
            //   filter: 'meterTokm',
            //   format: '',
            //   hirarchy: ['startOdometer'],
            //   isHirarchy: true,
            //   colName: 'startOdometer',
            // },
            // {
            //   titleName: 'Start Address',
            //   type: '',
            //   filter: 'address',
            //   format: '',
            //   hirarchy: ['startLat', 'startLon'],
            //   isHirarchy: true,
            //   colName: 'addressBylatLong',
            // },
            // {
            //   titleName: 'Odometer End',
            //   type: '',
            //   filter: 'meterTokm',
            //   format: '',
            //   hirarchy: ['endOdometer'],
            //   isHirarchy: true,
            //   colName: 'endOdometer',
            // },
            // {
            //   titleName: 'End Address',
            //   type: '',
            //   filter: 'address',
            //   format: '',
            //   hirarchy: ['endLat', 'endLon'],
            //   isHirarchy: true,
            //   colName: 'addressBylatLong',
            // },
            // {
            //   titleName: 'Distance',
            //   type: '',
            //   filter: 'meterTokm',
            //   format: '',
            //   hirarchy: ['distance'],
            //   isHirarchy: true,
            //   colName: 'distance',
            // }, {
            //   titleName: 'Average Speed',
            //   type: 'number',
            //   filter: '',
            //   format: '1.0-2',
            //   hirarchy: [],
            //   isHirarchy: false,
            //   colName: 'averageSpeed',
            // }, {
            //   titleName: 'Maximum Speed',
            //   type: 'number',
            //   filter: '',
            //   format: '1.0-2',
            //   hirarchy: [],
            //   isHirarchy: false,
            //   colName: 'maxSpeed',
            // },
            // {
            //   titleName: 'Duration',
            //   type: '',
            //   filter: 'convert',
            //   format: 'hh:mm',
            //   hirarchy: [],
            //   isHirarchy: false,
            //   colName: 'duration',
            // }
          ];
          break;
        case 'Stops':
          tableList = [
            {
              titleName: 'Device Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'deviceName',
            },
            {
              titleName: 'Start Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'startTime',
            },
            {
              titleName: 'Odometer',
              type: '',
              filter: 'meterTokm',
              format: '',
              hirarchy: ['startOdometer'],
              isHirarchy: true,
              colName: 'startOdometer',
            },
            {
              titleName: 'End Time',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'endTime',
            },
            {
              titleName: 'Duration',
              type: '',
              filter: 'convert',
              format: 'hh:mm',
              hirarchy: [],
              isHirarchy: false,
              colName: 'duration',
            },
            {
              titleName: 'Address',
              type: '',
              filter: 'address',
              format: '',
              hirarchy: ['latitude', 'longitude'],
              isHirarchy: true,
              colName: 'addressBylatLong',
            }, {
              titleName: 'Engine Hours',
              type: '',
              filter: 'convert',
              format: 'hh:mm',
              hirarchy: [],
              isHirarchy: false,
              colName: 'engineHours',
            }
          ];
          break;
        case 'Summary':
          tableList = [
            {
              titleName: 'Device Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'deviceName',
            },
            {
              titleName: 'Start Date',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'startTime',
            },
            {
              titleName: 'End Date',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'endTime',
            },
            {
              titleName: 'Distance',
              type: '',
              filter: 'meterTokm',
              format: '',
              hirarchy: ['distance'],
              isHirarchy: true,
              colName: 'distance',
            },
            {
              titleName: 'Start Address',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['startPosition', 'address'],
              isHirarchy: true,
              colName: 'startPosition',
            },
            {
              titleName: 'End Address',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['endPosition', 'address'],
              isHirarchy: true,
              colName: 'endPosition',
            },
            {
              titleName: 'Odometer Start',
              type: '',
              filter: 'meterTokm',
              format: '',
              hirarchy: ['startOdometer'],
              isHirarchy: true,
              colName: 'startOdometer',
            },
            // {
            //   titleName: 'Odometer End',
            //   type: '',
            //   filter: 'meterTokm',
            //   format: '',
            //   hirarchy: ['endOdometer'],
            //   isHirarchy: true,
            //   colName: 'endOdometer',
            // },
            {
              titleName: 'Average Speed',
              type: 'number',
              filter: 'userbased',
              format: '1.0-2',
              hirarchy: [],
              isHirarchy: false,
              colName: 'averageSpeed',
            }, {
              titleName: 'Maximum Speed',
              type: 'number',
              filter: 'userbased',
              format: '1.0-2',
              hirarchy: [],
              isHirarchy: false,
              colName: 'maxSpeed',
            },
            // {
            //   titleName: 'Engine Hours',
            //   type: '',
            //   filter: 'convert',
            //   format: 'hh:mm',
            //   hirarchy: [],
            //   isHirarchy: false,
            //   colName: 'engineHours',
            // },
            {
              titleName: 'Idle Hours',
              type: '',
              filter: 'convert',
              format: 'hh:mm',
              hirarchy: [],
              isHirarchy: false,
              colName: 'idleHours',
            },
            {
              titleName: 'Moving Hours',
              type: '',
              filter: 'convert',
              format: 'hh:mm',
              hirarchy: [],
              isHirarchy: false,
              colName: 'movingHours',
            },
            {
              titleName: 'Stop Hours',
              type: '',
              filter: 'convert',
              format: 'hh:mm',
              hirarchy: [],
              isHirarchy: false,
              colName: 'stopHours',
            }
          ];
          break;
        case 'Attendance':
          tableList = [
            {
              titleName: 'Employee Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'userName',
            },
            {
              titleName: 'Date',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'datetime',
            },
            {
              titleName: 'Latitude',
              type: 'number',
              filter: '',
              format: '1.0-4',
              hirarchy: [],
              isHirarchy: false,
              colName: 'latitude',
            },
            {
              titleName: 'longitude',
              type: 'number',
              filter: '',
              format: '1.0-4',
              hirarchy: [],
              isHirarchy: false,
              colName: 'longitude',
            },
            {
              titleName: 'Image',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'imagePath',
            },
          ];
        break;
        case 'Daily Summary':
          tableList = [
            {
              titleName: 'Device Name',
              type: '',
              filter: '',
              hirarchy: [],
              isHirarchy: false,
              colName: 'deviceName',
            },
            {
              titleName: 'Start Date',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'startTime',
            },
            {
              titleName: 'End Date',
              type: 'date',
              filter: '',
              format: 'dd/MM/yyyy hh:mm a',
              hirarchy: [],
              isHirarchy: false,
              colName: 'endTime',
            },
            {
              titleName: 'Distance',
              type: '',
              filter: 'meterTokm',
              format: '',
              hirarchy: ['distance'],
              isHirarchy: true,
              colName: 'distance',
            },
            {
              titleName: 'Start Address',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['startPosition', 'address'],
              isHirarchy: true,
              colName: 'startPosition',
            },
            {
              titleName: 'End Address',
              type: '',
              filter: '',
              format: '',
              hirarchy: ['endPosition', 'address'],
              isHirarchy: true,
              colName: 'endPosition',
            },
            {
              titleName: 'Odometer Start',
              type: '',
              filter: 'meterTokm',
              format: '',
              hirarchy: ['startOdometer'],
              isHirarchy: true,
              colName: 'startOdometer',
            },
            // {
            //   titleName: 'Odometer End',
            //   type: '',
            //   filter: 'meterTokm',
            //   format: '',
            //   hirarchy: ['endOdometer'],
            //   isHirarchy: true,
            //   colName: 'endOdometer',
            // },
            {
              titleName: 'Average Speed',
              type: 'number',
              filter: 'userbased',
              format: '1.0-2',
              hirarchy: [],
              isHirarchy: false,
              colName: 'averageSpeed',
            }, {
              titleName: 'Maximum Speed',
              type: 'number',
              filter: 'userbased',
              format: '1.0-2',
              hirarchy: [],
              isHirarchy: false,
              colName: 'maxSpeed',
            }
            // ,
            // {
            //   titleName: 'Engine Hours',
            //   type: '',
            //   filter: 'convert',
            //   format: 'hh:mm',
            //   hirarchy: [],
            //   isHirarchy: false,
            //   colName: 'engineHours',
            // }
          ];
          break;
        
      }
  
      this.xlsxFileData = [];
      if (type === 'xlsx') {
        if (this.reportsName === 'Chart') {
          
          this.exportExcel(this.xlsxFileData, this.reportsName);
        } else {
          // this.reportsList.forEach((r: any, i: number) => {
          //   let dataSet = {};
          //   tableList.forEach((t: any) => {
          //     dataSet[t.titleName] = r[t.colName] ? r[t.colName] : '';
          //   });
          //   this.xlsxFileData.push(dataSet);
          // });
          // this.exportExcel(this.xlsxFileData, this.reportsName);
  
          this.exportexcel();
        }
      } 
      else {
        // let htmlheader = `<table class="pdf-container">
        // <tbody><tr><td style="width:70%">INNOVATIVE TELEMATICS SOLUTIONS PVT. LTD.</td><td style="width:30%">${this.reportsName} Report</td>
        // </tbody></table>`;
  
        // let htmlheader = `<span style="width:70%;">INNOVATIVE TELEMATICS SOLUTIONS PVT. LTD.</span>
        // <span style="width:29%;">${this.reportsName} Reports</span>`;
        //let html = `<style>.pdf-container { font-size:6px;} </style><table class="border pdf-container"><thead><tr>`;
        this.tableForPdfColumns = [];
        this.tableForPdfContent = [];
        tableList.forEach((t) => {
          //html += `<th>${t.titleName}</th>`;
          this.tableForPdfColumns.push(t.titleName);
        });
        //html += `</tr></thead><tbody>`;
        this.taskListData.forEach((r: any, i: number) => {
          //html += `<tr>`;
          this.tableForPdfContent[i] = [];
          tableList.forEach((t: any, j: number) => {
          
              //html += `<td>${r[t.colName] ? r[t.colName] : ''}</td>`;
              this.tableForPdfContent[i][j] = `${r[t.colName] ? r[t.colName] : ''}`;
            
          });
          //html += `</tr>`;
        });
        //html += `</tbody></table>`;
  
        this.htmlString = '';
  
        setTimeout(() => {
          const pdfTable = this.pdfTable.nativeElement;
          // this.convetHtmlToPDF(pdfTable.innerHTML);
          this.downloadAsPDF();
        }, 2000);
      }
    }

    downloadAsPDF() {
      debugger
      const doc = new jsPDF();
      let fontSizeTable = this.reportsName == 'Trips' || this.reportsName == 'Summary' || this.reportsName == 'Route' ? 8:10;
      // const startdate = new Date(`${this.fromdateP} ${this.fromDateHours}:${this.fromDateMinutes}`);
      // const enddate = new Date(`${this.todateP} ${this.toDateHours}:${this.toDateMinutes}`);
      let title1 = 'MultiTrack';
      let title2 = (this.reportsName == 'Summary' ?'MIS':this.reportsName) + ' Report';
      let deviceName = '';
      // if (this.Device_ID && this.reportsName != 'Summary') {
      //   deviceName = this.DeviceArray.filter(x => x.id == this.Device_ID)[0].name;
      // }
      // if (this.myControl.value && this.myControl.value.length > 0 && this.reportsName == 'Summary') {
      //   this.myControl.value.forEach(element => {
      //     deviceName += element.name + ', ';
      //   });
      //   deviceName = deviceName.substring(0, deviceName.length - 2);
      // }
      const pdfTable = this.pdfTable.nativeElement;
      let html = htmlToPdfmake(pdfTable.innerHTML, {
        tableAutoSize:true
      });
  
      //const documentDefinition = { content: html };
      let contentOfTable:any[] = [];
      this.tableForPdfContent.forEach(ele => {
        contentOfTable.push(ele);
      });
  
      const documentDefinition =
      {
        content: [
          {
            columns: [
              {
                text: 'Roster',
                width: 100,
                margin: [0, 0, 0, 10]         
              },
              {
                width: '*',
                text: title2,
                style: 'title2',
                alignment: 'right'
              }
            ]
          },
          {
            columns: [
              {
                text: '',
                // style: 'tableExample',
                // table: {
                //   body: [
                //     [
                //       {
                //         text: `Asset Name: ${deviceName}`,
                //         bold: true,
                //       },
                //       {
                //         text: 'Group: NA',
                //         bold: true
                //       }
                //     ],
                //     [
                //       {
                //         text: [
                //           {text: `Report Period: ` , style: 'fontBold'},
                //           `${moment(startdate).format('DD/MMM/yyyy hh:mm:ss A')} - ${moment(enddate).format('DD/MMM/yyyy hh:mm:ss A')}`,
                //         ],
                //         colSpan: 2
                //       }
                //     ],
                //     [
                //       {
                //         text: [
                //           { text: `Report Run Time: `, style: 'fontBold'},
                //         `${moment().format('DD/MMM/yyyy hh:mm:ss A')}`,
                //         ],
                //         colSpan: 2
                //       }
                //     ]
                //   ]
                // },
                width: 420
              },
              {
                style: 'tableExample',
                table: {
                  body: [
                    [
                      {
                        text: `Print By: ${this.userdata.name}`,
                        bold: true,
                        style: 'printby'
                      }
                    ],
                    [
                      {
                        text: `Remarks: - NA`,
                        bold: true,
                        style: 'remarks'
                      }
                    ]
                  ]
                },
                width: '*'
              }
            ]
          },
          {
            style: 'tablecss',
            table: {
              body: [
                [...this.tableForPdfColumns],
                ...contentOfTable
              ]
            },
            layout: {
              fillColor: function (rowIndex, node, columnIndex) {
                return (rowIndex == 0) ? '#CCCCCC' : null;
              }
            }
          }
        ],
        styles: {
          tablecss: {
            fontSize: fontSizeTable
          },
          tableStyle: {
  
          },
          testing: {
            bold: true,
            fontSize: 40
          },
          title1: {
            margin: [0, 0, 0, 10],
            fontSize: 10
          },
          title2: {
  
          },
          tableExample: {
            border: 0,
            margin: [0, 0, 5, 10],
            fontSize: 10
          },
          printby: {
            fontSize: 10,
          },
          remarks: {
            fontSize: 10,
          },
          fontBold: {
            bold: true
          }
        }
      };
  
      pdfMake.createPdf(documentDefinition).open();
  
  
      // const documentDefinition =
      // {
      //   content: [
      //     { text: 'Heading test', style: 'testing' },
      //     htmlToPdfmake(pdfTable.innerHTML)
      //   ],
      //   styles: {
      //     testing: {
      //       bold: true,
      //       fontSize: 50
      //     }
      //   }
      // };
  
      // this.htmlString = '';
    }
    exportExcel(xlsxFileData: any[], fileName: string) {
     
      const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(xlsxFileData);
      const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
      const excelBuffer: any = XLSX.write(wb, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveExcelFile(excelBuffer, fileName);
    }
    exportexcel(): void
    {
    
      /* pass here the table id */
      let element = document.getElementById('report-table');
      const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, this.reportsName +'.xlsx');
  
      // setTimeout(()=>{
      //   this.page = lastPage;
      //   this.pageOption = lastPerPage;
      // },100)
    }
    saveExcelFile(buffer: any, fileName: string): void {
     
      const data: Blob = new Blob([buffer], { type: this.fileType });
      FileSaver.saveAs(data, fileName + this.fileExtension);
    }


    setReportsDate() {
      let now = moment();
      switch (this.dayType) {
          // case 'Today':
          //     this.fromdateP = now.startOf('day').format("yyyy-MM-DD");
          //     this.todateP = now.endOf('day').format("yyyy-MM-DD");
           
          //   break;
          // case 'Yesterday':
          //   this.fromdateP = now.subtract(1, 'day').startOf('day').format("yyyy-MM-DD");
          //   this.todateP = now.endOf('day').format("yyyy-MM-DD");
          
          //   break;
          // case 'Week':
          //   this.fromdateP = now.startOf('week').format("yyyy-MM-DD");
          //   this.todateP = now.endOf('week').format("yyyy-MM-DD");

          //   break;
          // case 'Month':
          //   this.fromdateP = now.startOf('month').format("yyyy-MM-DD");
          
          //   this.todateP = now.endOf('month').format("yyyy-MM-DD");
          
          //   break;
          // case 'Last Month':
          //   this.fromdateP = now.subtract(1, 'month').startOf('month').format("yyyy-MM-DD");
          
          //   this.todateP = now.endOf('month').format("yyyy-MM-DD");
           
          //   break;
          // case 'Custom':
          //   if (!this.fromdateP) {
          //     this.fromdateP = now.startOf('day').format("yyyy-MM-DD");
              
          //     this.todateP = now.endOf('day').format("yyyy-MM-DD");
             
          //   }
          //   break;
          // default:
          //   break;


          case 'Today':
            this.fromdateP = now.startOf('day').format("DD/MM/YYYY");
            this.todateP = now.endOf('day').format("DD/MM/YYYY");
            break;
          case 'Yesterday':
            this.fromdateP = now.subtract(1, 'day').startOf('day').format("DD/MM/YYYY");
            this.todateP = now.endOf('day').format("DD/MM/YYYY");
            break;
          case 'Week':
            this.fromdateP = now.startOf('week').format("DD/MM/YYYY");
            this.todateP = now.endOf('week').format("DD/MM/YYYY");
            break;
          case 'Month':
            this.fromdateP = now.startOf('month').format("DD/MM/YYYY");
            this.todateP = now.endOf('month').format("DD/MM/YYYY");
            break;
          case 'Last Month':
            this.fromdateP = now.subtract(1, 'month').startOf('month').format("DD/MM/YYYY");
            this.todateP = now.endOf('month').format("DD/MM/YYYY");
            break;
          case 'Custom':
            if (!this.fromdateP) {
              this.fromdateP = now.startOf('day').format("DD/MM/YYYY");
              this.todateP = now.endOf('day').format("DD/MM/YYYY");
            }
            break;
          default:
            break;
        
      }
      console.log("from date",this.fromdateP)
      console.log("to date",this.todateP)
    }

    calculateDuration(tripstartime,tripendtime){
      if(tripstartime && tripendtime){
        let tripStartTime: Date = new Date(tripstartime);
        let  tripEndTime: Date = new Date(tripendtime);
        const durationInMillis = tripEndTime.getTime() - tripStartTime.getTime();
        const durationInSeconds = Math.floor(durationInMillis / 1000);
       const hours = Math.floor(durationInSeconds / 3600);
       const minutes = Math.floor((durationInSeconds % 3600) / 60);
         const seconds = durationInSeconds % 60;
         let durationString = '';

         if (hours > 0) {
           durationString += `${hours}hr`;
         }
       
         if (minutes >= 0) {
           if (durationString.length > 0) {
             durationString += ':';
           }
           durationString += `${minutes}min`;
         }
       
         return durationString;
      }
      return 'N/A';
    
     }

    //  convertToLocalTime(datetime:any){
    //   if(datetime != 'undefined'){
    //     const inputTime = new Date(datetime);
    
    //     // Convert to local time
    //     const localTime = this.datePipe.transform(inputTime, 'medium', 'local');
    
    //     console.log('Local Time:', localTime);
    //     return localTime;
    //   }
    //   return 'N/A';
     
    //  }

    statusChange(event:any){
     debugger
      console.log(event.target.value)
      if(event.target.value !== '0'){
      this.status=event.target.value
      }
      else{
        this.status='';
      }
    }
  }

